import { Grid, Paper, TableFooter, TablePagination, TextField } from "@material-ui/core";
import {
    createStyles, makeStyles,
    Theme, withStyles
} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import Button from '@mui/material/Button';
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { generateGenomicsResearchUrl } from "../../../../helpers/generateUrl";
import { getSequencing } from "../../store/actions";
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        table: {
            minWidth: 700,
        },
        toolbar: {
            alignItems: "center",
            justifyContent: "flex-end",
            padding: theme.spacing(0, 1),
            ...theme.mixins.toolbar,
        },
        input: {
            padding: "1px",
        },
        paper: {
            padding: theme.spacing(2),
            textAlign: "left",
            color: theme.palette.text.secondary,
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
        card: {
            height: "100%",
            padding: "20px",
        },
        text: { color: "black" },
    })
);

const StyledTableCell: any = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: "#12145e",
            color: theme.palette.common.white,
            fontSize: "14px",
        },
        body: {
            fontSize: 14,
        },
    })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
    createStyles({
        root: {
            "&:nth-of-type(odd)": {
                backgroundColor: theme.palette.action.hover,
            },
        },
    })
)(TableRow);
interface Props {
    getSequencing: any;
    fetchRunSequencing: any;

}
const StopsPlace: React.FC<Props> = ({
    getSequencing,
    fetchRunSequencing,


}) => {
    const classes = useStyles();
    const history = useHistory();
    const timer = useRef<any>(0);
    const [lab, setLab] = React.useState<any>("");
    const [sampleId, setSampleId] = useState<any>("");
    const [runId, setRunId] = useState<any>();
    const [page, setPage] = useState(0);

    useEffect(() => {
        getSequencing();
    }, [])

    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number
    ) => {
        if (newPage > page) {
            let url = fetchRunSequencing.links && fetchRunSequencing.links.next.split("?")[1];
            getSequencing(`?${url}`);
        } else if (newPage < page) {
            let url = fetchRunSequencing.links && fetchRunSequencing.links.previous.split("?")[1];
            getSequencing(`${url === undefined ? "" : "?" + url}`);
        }
        setPage(newPage);
    };
    const filterDataQc = (e: any) => {
        const body: any = {
            runId: runId,
        };
        const url = generateGenomicsResearchUrl(body).substring(2);
        getSequencing(url);
        setPage(0);
    };

    return (
    <form style={{ width: "100%", marginLeft: 14 }} onSubmit={filterDataQc}>
        <Grid container spacing={2} style={{ marginTop: 50 }}>
            <Grid container spacing={3}>
                <Grid item xs={10}>
                    <h3>Data QC Dashboard</h3>
                </Grid>
            </Grid>
            <Grid
                container
                spacing={1}
                direction="row"
                style={{ marginTop: 10 }}
            >

                <Grid item xs={12} sm={4}>
                    <Autocomplete
                        id="RunID"
                        onChange={(event, newValue) => {
                            setRunId(newValue?.runId);
                        }}
                        options={fetchRunSequencing?.results || []}
                        blurOnSelect
                        getOptionLabel={(option: any) => {
                            return (
                                (option?.runId)
                            );
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                className="input"
                                label="Run ID"
                                variant="outlined"
                                placeholder="Search Run ID"
                                fullWidth
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <Button
                        variant="contained"
                        color="secondary"
                        fullWidth
                        onClick={filterDataQc}
                    >
                        Filter
                    </Button>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={() => history.go("/dashboard/gnrelab/dataqc")}
                    >
                        Reset
                    </Button>
                </Grid>
            </Grid>
            <Grid container style={{ marginTop: 10 }}>
                <TableContainer
                    className={classes.tableContainer}
                    component={Paper}
                    style={{ maxHeight: "540px" }}
                >
                    <Table stickyHeader aria-label="simple table">
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell align="center">Run ID</StyledTableCell>
                                <StyledTableCell align="center">Flow Cell</StyledTableCell>
                                <StyledTableCell align="center">Lane</StyledTableCell>
                                <StyledTableCell align="center">Single Index</StyledTableCell>
                                <StyledTableCell align="center">Dual Index</StyledTableCell>
                                {/* <StyledTableCell align="center">Lib Type</StyledTableCell> */}
                                <StyledTableCell align="center">Chemistry</StyledTableCell>
                                <StyledTableCell align="center">Enter Data Capture</StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                        {fetchRunSequencing && fetchRunSequencing?.results && fetchRunSequencing?.results?.map((data: any, index: any) =>
                                    <StyledTableRow>
                                        <StyledTableCell align="center">
                                            {data?.runId}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.flowCellType}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.lanes}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.singleIndexCount}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.dualIndexCount}
                                        </StyledTableCell>
                                        {/* <StyledTableCell align="center">
                                            {data?.sequencing?.type}
                                        </StyledTableCell> */}
                                        <StyledTableCell align="center">
                                            {data?.chemistry}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            <Link to={`/dashboard/gnrelab/dataqc/new/${data?._id}`} style={{ textDecoration: "none" }}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                >
                                                    <ExitToAppIcon />
                                                </Button>
                                            </Link>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                )}
                        </TableBody>
                        <TableFooter>
                            <TablePagination
                                rowsPerPageOptions={[]}
                                colSpan={3}
                                count={fetchRunSequencing?.count || 0}
                                rowsPerPage={fetchRunSequencing?.page_size}
                                page={page}
                                onPageChange={handleChangePage}
                            />
                        </TableFooter>
                    </Table>
                </TableContainer>
            </Grid>
        </Grid>
        </form>
    );
};
const mapStateToProps = (state: any) => ({
    fetchRunSequencing: state.GenomicsLabReducer.fetchRunSequencing,
});
export default connect(mapStateToProps, {
    getSequencing,

})(StopsPlace);
